module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-ExtraBold.607e47e4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-ExtraBold.woff
// module id = 2359
// module chunks = 50